(() => {
'use strict';
const finishNames = value => String(value || '').replace(/Schwarz Glänzend Frontpoliert/gi,'Glanzend zwart gepolijst').replace(/Schwarz Matt Poliert/gi,'Matzwart gepolijst').replace(/Schwarz Poliert/gi,'Zwart gepolijst').replace(/Schwarz Matt/gi,'Matzwart').replace(/Schwarz Glänzend/gi,'Glanzend zwart').replace(/Brillantsilber/gi,'Briljantzilver').replace(/Kristallschwarz/gi,'Kristalzwart').replace(/Mattschwarz/gi,'Matzwart').replace(/Schwarz/gi,'Zwart').replace(/Graphit(?:e)?/gi,'Grafiet').replace(/Silber/gi,'Zilver').replace(/Poliert/gi,'Gepolijst').replace(/Matt/gi,'Mat').replace(/\bBlack\b/gi,'Zwart').replace(/\bPolish(?:ed)?\b/gi,'Gepolijst').replace(/\bGlossy\b/gi,'Glanzend').replace(/\bSilver\b/gi,'Zilver').replace(/\bBronce\b/gi,'Brons');
const displayLabel = value => finishNames(window.BandenmeestersDisplayLabels?.format(value) ?? value);
const money = cents => new Intl.NumberFormat('nl-BE',{style:'currency',currency:'EUR'}).format(cents/100);
const officialMakerLogos = new Map();
const load = async root => {
if (root.dataset.loaded) return; root.dataset.loaded='true';
  const renderCard = (family, index) => {
    const template = root.querySelector('[data-bm-new-card-template]');
    const finishTemplate = root.querySelector('[data-bm-new-finish-template]');
    if (!template || !finishTemplate) return null;

    const item = template.content.firstElementChild.cloneNode(true);
    const primary = family.primaryProduct;
    const primaryFinish = family.finishOptions.find((finish) =>
      finish.shopifyProductRef === primary.shopifyProductRef
    );
    if (!primaryFinish) return null;

    const title = `${displayLabel(family.manufacturer)} ${displayLabel(family.designName)}`;
    const label = `${title} — ${displayLabel(primaryFinish.finish)}`;
    item.querySelectorAll('.bm-inventory-card__media, .bm-new-card__title a, .bm-new-card__cta').forEach((link) => {
      link.href = primary.productUrl;
      link.setAttribute('aria-label', `Bekijk velg: ${label}`);
    });

    const image = item.querySelector('.bm-inventory-card__image');
    const imageUrl = window.BandenmeestersNewClient?.shopifyImageUrl;
    image.loading = index < 4 ? 'eager' : 'lazy';
    image.fetchPriority = index < 2 ? 'high' : 'auto';
    image.decoding = 'async';
    image.alt = label;
    if (imageUrl) {
      image.srcset = [240, 480, 720, 960].map(width => `${imageUrl(primary.primaryImageUrl, width)} ${width}w`).join(', ');
      image.sizes = '(min-width:1101px) 300px, 50vw';
    }
    image.src = imageUrl?.(primary.primaryImageUrl, 480) || primary.primaryImageUrl;

    const officialMark = item.querySelector('.bm-new-card__maker-logo');
    const makerIdentity = officialMakerLogos.get(String(family.manufacturer || ''));
    if (officialMark) {
      if (makerIdentity) {
        officialMark.src = makerIdentity.logo;
        officialMark.alt = 'Officieel merklogo ' + family.manufacturer;
        officialMark.dataset.surface = makerIdentity.surface === 'dark' ? 'dark' : 'light';
        officialMark.hidden = false;
        officialMark.addEventListener('error', () => { officialMark.hidden = true; officialMark.removeAttribute('src'); }, { once: true });
      } else {
        officialMark.hidden = true;
        officialMark.removeAttribute('src');
      }
    }

    item.querySelector('[data-bm-new-maker-text]').textContent = displayLabel(family.manufacturer);
    item.querySelector('.bm-new-card__title a').textContent = displayLabel(family.designName);
    item.querySelector('.bm-new-card__finish-label').textContent = displayLabel(primaryFinish.finish);

    const diameters = item.querySelector('.bm-new-card__diameters');
    family.sizeOptions.forEach((size) => {
      const chip = document.createElement('li');
      chip.className = 'bm-new-card__diameter';
      chip.textContent = `${size} inch`;
      diameters.append(chip);
    });
    const sizeRow = item.querySelector('.bm-new-card__size-row');
    if (sizeRow) sizeRow.hidden = !family.sizeOptions.length;
    diameters.hidden = !family.sizeOptions.length;

    const price = item.querySelector('.bm-new-card__price strong');
    const priceLine = item.querySelector('.bm-new-card__price > span:first-child');
    const priceUnit = item.querySelector('.bm-new-card__price-unit');
    const commerceFacts = item.querySelector('[data-bm-card-commerce]');
    if (commerceFacts) {
      const facts = window.BandenmeestersNewClient?.cardCommerceFacts?.(primaryFinish) || 'Voorraad en levering bij maatkeuze';
      commerceFacts.textContent = facts;
      if (facts === 'Beschikbaar') {
        commerceFacts.classList.add('bm-new-card__commerce-facts--in-stock');
        commerceFacts.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m12 3 9 5v8l-9 5-9-5V8l9-5Z"/><path d="m3 8 9 5 9-5M12 13v8M7.5 5.5l9 5V15"/></svg><span>Op voorraad</span>';
      }
    }
    // Same canonical price/no-price rendering as the NEW results and PDP family card.
    if (family.fromSetPrice4 === null) {
      if (priceLine?.firstChild?.nodeType === 3) priceLine.firstChild.textContent = '';
      if (price) price.textContent = 'Prijs op aanvraag';
      if (priceUnit) priceUnit.hidden = true;
    } else if (price) {
      price.textContent = money(family.fromSetPrice4.amountCents);
    }

    const finishes = item.querySelector('.bm-new-card__finishes');
    family.finishOptions.slice(0, 3).forEach((finish) => {
      const link = finishTemplate.content.firstElementChild.cloneNode(true);
      link.href = finish.productUrl;
      link.setAttribute('aria-label', `${title} — ${displayLabel(finish.finish)}`);
      if (finish.shopifyProductRef === primary.shopifyProductRef) {
        link.classList.add('is-active');
        link.setAttribute('aria-current', 'page');
      }
      const photo = link.querySelector('img');
      photo.src = imageUrl?.(finish.primaryImageUrl, 90) || finish.primaryImageUrl;
      photo.alt = `${title} ${displayLabel(finish.finish)}`;
      finishes.append(link);
    });
    finishes.hidden = family.finishOptions.length < 2;

    const wishlist = item.querySelector('[data-bm-new-wishlist]');
    wishlist.dataset.productId = primary.shopifyProductRef;
    wishlist.dataset.productUrl = primary.productUrl;
    wishlist.setAttribute('aria-label', `Bewaar ${label} in je verlanglijst`);
    return item;
  };


try {
const page = await window.BandenmeestersNewClient.familyListing({filters:{manufacturer:root.dataset.manufacturer,limit:4,offset:0,sort:'BRAND_DESIGN_ASC'},priceContract:'OPTIONAL_CANONICAL_PRICE_V1'});
const cards=page.results.map(renderCard).filter(Boolean);
root.querySelector('.bm-brand-directory__loading')?.remove();
if(cards.length){ root.querySelector('.bm-brand-directory__fallback')?.remove(); root.append(...cards); window.BMNewWishlist?.refresh?.(); }
else if(!root.querySelector('.bm-brand-directory__fallback article')) { const p=document.createElement('p');p.className='bm-brand-directory__loading';p.textContent='Momenteel geen velgen van dit merk online.';root.append(p); }
} catch (_) { const p=root.querySelector('[role="status"]'); if(p) p.textContent='Het aanbod kan nu niet geladen worden. Bekijk de merkcollectie via de link hierboven.'; }
};
const observer = new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){observer.unobserve(entry.target);load(entry.target);}}),{rootMargin:'250px'});
document.querySelectorAll('[data-bm-brand-products]').forEach(root=>{
root.querySelectorAll('.bm-brand-directory__fallback .bm-new-card__title a').forEach(a=>{
const parts=a.textContent.split(/\s+[—–]\s+/); const maker=root.dataset.manufacturer; const design=parts[0].replace(new RegExp('^'+maker+'\\s+','i'),''); a.textContent=design.includes('-')||design.length<=3?design:displayLabel(design);
if(parts[1]) {const p=document.createElement('p');p.className='bm-new-card__finish-label';p.textContent=displayLabel(parts.slice(1).join(' · '));a.closest('h3').after(p);}
});
observer.observe(root);
});
})();